import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  FetchScoreAllocationsPayload,
  ScoreAllocationItem,
  ScoreAllocationListResponse,
} from 'features/Yucollect/Score/types/Score.types';

export interface ScoreListState {
  data: ScoreAllocationItem[];
  page: number;
  pageSize: number;
  totalCount: number;
  loading: boolean;
  error: string | null;
}

export const scoreListInitialState: ScoreListState = {
  data: [],
  page: 1,
  pageSize: 20,
  totalCount: 0,
  loading: false,
  error: null,
};

const scoreListSlice = createSlice({
  name: 'scoreList',
  initialState: scoreListInitialState,
  reducers: {
    fetchScoreAllocationsReq(
      state,
      _action: PayloadAction<FetchScoreAllocationsPayload>
    ) {
      state.loading = true;
      state.error = null;
    },
    fetchScoreAllocationsSuccess(
      state,
      action: PayloadAction<ScoreAllocationListResponse>
    ) {
      state.data = action.payload.data;
      state.totalCount = action.payload.totalCount;
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.loading = false;
      state.error = null;
    },
    fetchScoreAllocationsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetScoreList: () => scoreListInitialState,
  },
});

export const {
  fetchScoreAllocationsReq,
  fetchScoreAllocationsSuccess,
  fetchScoreAllocationsFailure,
  resetScoreList,
} = scoreListSlice.actions;

export default scoreListSlice.reducer;
